export default __webpack_public_path__ + "static/media/editPasswordExcl.eb70160e.svg";